import { globalColors } from "../../Utils/colors";
import { Backdrop, CircularProgress } from "@mui/material";

interface CustomMuiBackDropProps {
  loading: boolean;
}

export default function CustomMuiBackDrop({ loading }: CustomMuiBackDropProps) {
  return (
    <Backdrop
      open={loading}
      sx={{
        color: globalColors.white,
        zIndex: (theme) => theme.zIndex.drawer + 1,
      }}
    >
      <CircularProgress color="inherit" />
    </Backdrop>
  );
}
